<template>
  <div id="nav">
    <b-navbar toggleable="lg" type="dark" variant="info" fixed="top">
      <b-navbar-brand @click="scrollTo('nosotros')"><img src="@/assets/images/logo.png" /></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" v-model="showCollapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <li class="nav-item"><div @click="scrollTo('nuestro-trabajo')">Nuestro trabajo</div></li>
          <li class="nav-item"><div @click="scrollTo('productos')">Productos</div></li>
          <li class="nav-item"><div @click="scrollTo('proyectos')">Proyectos</div></li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showCollapse: false
    }
  },
  watch: {
    '$route' () {
      this.showCollapse = false
    }
  },
  methods: {
    scrollTo (elementId) {
      document.querySelector('#' + elementId).scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.showCollapse = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.close)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.close)
  }
}
</script>

<style lang="scss">
#nav {
  .bg-info {
    background-color: #b5b5b5 !important;
    padding: 20px !important;
  }

  .navbar {
    height: 100px;

    img {
      height: 70px;
    }

    .navbar-brand {
      cursor: pointer;
    }
  }

  .nav-item {
    color: #495057;
    padding: 0 10px;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
